import React, { createRef, useEffect, useRef } from 'react';

import gsap from 'gsap';

const MainNav = (props) => {
    const menu = createRef();
    const menuContainer = createRef();
    const isToggled = useRef(false);
    const collapseDuration = 0.2;
    const currentTimeline = createRef(null);

    const toggleMenu = () => {
        if (!isToggled.current) {
            expand();
        } else {
            collapse();
        }
        isToggled.current = !isToggled.current;
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!menuContainer.current) return;
            if (!menuContainer.current.contains(e.target)) {
                if (isToggled.current) {
                    collapse();
                    isToggled.current = !isToggled.current;
                }
            }
        };

        const handleKeyPress = (e) => {
            if (!menuContainer.current) return;

            if (e.keyCode === 27 && isToggled.current) {
                collapse();
                isToggled.current = !isToggled.current;
            }
        };

        if (menuContainer.current) {
            menuContainer.current.addEventListener('keydown', handleKeyPress);
        }
        document.addEventListener('click', handleClickOutside);

        return () => {
            if (!menuContainer.current) return;
            menuContainer.current.removeEventListener('keydown', handleKeyPress);
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const expand = () => {
        currentTimeline.current && currentTimeline.current.kill();
        const tl = gsap.timeline();
        gsap.set(menu.current, { display: 'block' });
        gsap.set(menu.current, { height: 'auto' });
        tl.from(menu.current, { height: 0, duration: collapseDuration });
        currentTimeline.current = tl;
    };

    const collapse = () => {
        currentTimeline.current && currentTimeline.current.kill();
        const tl = gsap.timeline();
        tl.to(menu.current, { height: 0, duration: collapseDuration });
        tl.to(menu.current, { display: 'none' }, 0.3);
        currentTimeline.current = tl;
    };

    return (
        <div className="navbar w-nav">
            {/* Begin provided banner */}
            <div className="section-6">
                <div className="columns-38 w-row">
                    <div className="column-92 w-col w-col-6 w-col-medium-6 w-col-small-6 w-col-tiny-6">
                        <a href="https://www.dfes.wa.gov.au/contactus/Pages/default.aspx" className="link-block-2 w-inline-block">
                            <img
                                src="/annualreport2020/images/template/phone-icon_1phone-icon.png"
                                width="20"
                                alt=" "
                                className="image-42"
                            />
                            <div>Contact Us</div>
                        </a>
                    </div>
                    <div className="column-92 w-col w-col-6 w-col-medium-6 w-col-small-6 w-col-tiny-6">
                        <a
                            href="https://www.emergency.wa.gov.au/"
                            target="_blank"
                            className="link-block-2 warning w-inline-block emergency-link-focus"
                        >
                            <img
                                src="https://uploads-ssl.webflow.com/5eb2156768b14a047e99249b/5eb2156768b14a75b79925a9_icon-alert-white.png"
                                alt=""
                                className="image-43"
                            />
                            <div>Alerts &amp; Warnings</div>
                        </a>
                    </div>
                </div>
                <div className="columns-32 top-navigation w-row">
                    <div className="column-79 w-col w-col-6">
                        <div className="div-block-27">
                            <a href="https://www.dfes.wa.gov.au/pages/accessibility.aspx" className="button-3 w-button">
                                Accessibility
                            </a>
                            <a href="https://www.dfes.wa.gov.au/contactus/Pages/default.aspx" className="button-4 w-button">
                                Contact Us
                            </a>
                        </div>
                    </div>
                    <div className="column-79 w-col w-col-6">
                        <div className="div-block-28">
                            <a
                                href="https://www.facebook.com/dfeswa"
                                target="_blank"
                                className="link-block w-inline-block"
                                aria-label="Visit our Facebook page"
                            ></a>
                            <a
                                href="https://twitter.com/dfes_wa"
                                target="_blank"
                                className="link-block twitter w-inline-block"
                                aria-label="Visit our Twitter page"
                            ></a>
                            <a
                                href="https://www.youtube.com/user/DFESWesternAustralia"
                                target="_blank"
                                className="link-block youtube w-inline-block"
                                aria-label="Visit our YouTube page"
                            ></a>
                            <a
                                href="https://www.instagram.com/dfes_wa"
                                target="_blank"
                                className="link-block instagram w-inline-block"
                                aria-label="Visit our Instagram page"
                            ></a>
                            <a
                                href="https://au.linkedin.com/company/fire-&amp;-emergency-services-authority"
                                target="_blank"
                                aria-label="Visit our LinkedIn page"
                                className="link-block linkedin w-inline-block"
                            ></a>
                        </div>
                    </div>
                </div>
                <div className="columns-32 navigation w-row">
                    <div className="column-76 left-aligned w-col w-col-2">
                        <div className="div-block-29">
                            <a href="https://www.wa.gov.au/" className="w-inline-block">
                                <img
                                    src="https://uploads-ssl.webflow.com/5ea93eb0a548bff01f1aa8f6/5ea93eb0a548bf4e391aa9c0_icon-wa-badge-white.png"
                                    alt="Government of Western Australia"
                                    className="logo"
                                />
                            </a>
                            <a href="https://www.dfes.wa.gov.au" className="w-inline-block">
                                <img
                                    src="https://uploads-ssl.webflow.com/5ea93eb0a548bff01f1aa8f6/5ea93eb0a548bf34b51aa9d2_icon-dfes-white.png"
                                    alt="Department of Fire and Emergency Services WA "
                                    className="logo"
                                />
                            </a>
                        </div>
                    </div>
                    <div className="column-76 w-col w-col-10">
                        <div className="div-block-23 w-clearfix">
                            <img
                                src="https://uploads-ssl.webflow.com/5ea93eb0a548bff01f1aa8f6/5ea93eb0a548bf6f1f1aa9cc_icon-phone-white.png"
                                alt=""
                                className="image-18"
                            />
                            <div className="nav-fire">
                                000
                                <br />
                                <span className="text-span-4">Fire or life threatening emergencies</span>
                            </div>
                        </div>
                        <div className="div-block-23 w-clearfix">
                            <img
                                src="https://uploads-ssl.webflow.com/5ea93eb0a548bff01f1aa8f6/5ea93eb0a548bf6f1f1aa9cc_icon-phone-white.png"
                                alt=""
                                className="image-20"
                            />
                            <div className="nav-emergency">
                                13 3337
                                <br />
                                <span className="text-span-6">Emergency Information</span>
                            </div>
                        </div>
                        <div className="div-block-23 w-clearfix">
                            <img
                                src="https://uploads-ssl.webflow.com/5ea93eb0a548bff01f1aa8f6/5ea93eb0a548bf6f1f1aa9cc_icon-phone-white.png"
                                alt=""
                                className="image-20"
                            />
                            <div className="text-block-6">
                                132 500
                                <br />
                                <span className="text-span-4">SES Emergency Assistance</span>
                            </div>
                        </div>
                        <a href="https://www.emergency.wa.gov.au/" target="_blank" className="w-inline-block emergency-link-focus">
                            <div className="div-block-23 w-clearfix">
                                <img
                                    src="https://uploads-ssl.webflow.com/5ea93eb0a548bff01f1aa8f6/5ea93eb0a548bf671e1aa9cd_icon-alert-white.png"
                                    alt=""
                                    className="image-14"
                                />
                                <div className="nav-alert">
                                    <strong className="bold-text">Alerts &amp; Warnings</strong>
                                    <br />
                                    emergency.wa.gov.au
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="dfes-nav-wrapper">
                    <div ref={menuContainer}>
                        <button className="dropdown-toggle-11 w-clearfix w-dropdown-toggle" onClick={toggleMenu}>
                            <span style={{ display: 'block' }}>MENU</span>
                            <img
                                src="https://uploads-ssl.webflow.com/5ea93eb0a548bff01f1aa8f6/5ea93eb0a548bf11961aa9c7_icon-hamburger-white.png"
                                alt=""
                                className="image-16"
                            />
                        </button>
                        <nav className="w-dropdown-list" ref={menu} id="dfes-nav-dropdown">
                            <div className="div-block-42">
                                <div className="div-block-31 _1">
                                    <a href="https://www.dfes.wa.gov.au/" className="dropdown-link-6 w-dropdown-link">
                                        Home
                                    </a>
                                    <a href="https://www.dfes.wa.gov.au/publications" className="dropdown-link-6 w-dropdown-link">
                                        Publications
                                    </a>
                                    <a href="https://www.dfes.wa.gov.au/pages/links.aspx" className="dropdown-link-6 w-dropdown-link">
                                        Links
                                    </a>
                                    <a href="https://www.dfes.wa.gov.au/contactus" className="dropdown-link-6 w-dropdown-link">
                                        Contact Us
                                    </a>
                                </div>
                                <div className="div-block-31 _2">
                                    <a
                                        href="https://www.dfes.wa.gov.au/aboutus/Pages/redirect.aspx"
                                        className="dropdown-link-6 w-dropdown-link"
                                    >
                                        About Us
                                    </a>
                                    <a
                                        href="https://www.dfes.wa.gov.au/newsandmedia/Pages/NewsHome.aspx"
                                        className="dropdown-link-6 w-dropdown-link"
                                    >
                                        News &amp; Media
                                    </a>
                                    <a
                                        href="https://www.dfes.wa.gov.au/safetyinformation/Pages/default.aspx"
                                        className="dropdown-link-6 w-dropdown-link"
                                    >
                                        Hazard Information
                                    </a>
                                    <a
                                        href="https://www.dfes.wa.gov.au/volunteers/Pages/default.aspx"
                                        className="dropdown-link-6 w-dropdown-link"
                                    >
                                        Volunteering
                                    </a>
                                </div>
                                <div className="div-block-31 _3">
                                    <a
                                        href="https://www.dfes.wa.gov.au/schooleducation/Pages/default.aspx"
                                        className="dropdown-link-6 w-dropdown-link"
                                    >
                                        School Education
                                    </a>
                                    <a
                                        href="https://www.dfes.wa.gov.au/recruitmentandtraining/Pages/redirect.aspx"
                                        className="dropdown-link-6 w-dropdown-link"
                                    >
                                        Recruitment &amp; Training
                                    </a>
                                    <a
                                        href="https://www.dfes.wa.gov.au/regulationandcompliance/Pages/redirect.aspx"
                                        className="dropdown-link-6 w-dropdown-link"
                                    >
                                        Regulation &amp; Compliance
                                    </a>
                                </div>
                                <div className="div-block-31 _4">
                                    <a
                                        href="https://www.dfes.wa.gov.au/emergencyserviceslevy/Pages/default.aspx"
                                        className="dropdown-link-6 w-dropdown-link"
                                    >
                                        Emergency Services Levy
                                    </a>
                                    <a
                                        href="https://www.dfes.wa.gov.au/waemergencyandriskmanagement/Pages/default.aspx"
                                        className="dropdown-link-6 w-dropdown-link"
                                    >
                                        WA Emergency &amp; Risk Management
                                    </a>
                                    <a
                                        href="https://www.dfes.wa.gov.au/recovery/Pages/default.aspx"
                                        className="dropdown-link-6 last w-dropdown-link"
                                    >
                                        Recovery (WANDRRA/DRFA-WA)
                                    </a>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
            {/* End provided banner */}
        </div>
    );
};

export default MainNav;
